import { render } from "./mecanicos.vue?vue&type=template&id=4c9099d2"
import script from "./mecanicos.vue?vue&type=script&lang=js"
export * from "./mecanicos.vue?vue&type=script&lang=js"
script.render = render

export default script